import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

const resourcePage = {
    department: "Physics",
    short: "physics",
    programmePath: "/programme/bsh/physics",
    description:
        "Access student resources for the Department of Physics including syllabus, timetable, academic calendar, lab manuals, question papers, add-on courses, publications, and mentor details.",
    sections: [
        {
            title: "IA Syllabus",
            items: [
                {
                    label: "IA Coverage",
                    href: "https://drive.google.com/file/d/1nv7jsd4BepFeiYRkGXYq4eZu28jX3ALK/view?usp=drive_link"
                }
            ],
        },
        {
            title: "Timetable",
            items: [
                {
                    label: "Timetable",
                    href: "https://drive.google.com/file/d/1KPSYRC4Miy3CpNe14nbYaL8NsRokr86B/view?usp=drive_link"
                }
            ],
        },
        {
            title: "Academic Calendar",
            items: [
                {
                    label: "Calendar of Events",
                    href: "https://drive.google.com/file/d/1daygHO3VhNlNC8R3OGDOehTbisW1KMN7/view?usp=drive_link"
                }
            ],
        },
        // {
        //     title: "Lab Manuals",
        //     items: [{ label: "Physics Lab Manual", href: "#" }],
        // },
        {
            title: "Question Papers & Solutions",
            items: [
                {
                    label: "Physics Question Papers and Solutions",
                    href: "https://drive.google.com/drive/folders/1RSJU4W9oZKZSRtPSZV1A9lwu0HYcVMSe?usp=drive_link"
                }
            ],
        },
        // {
        //     title: "Add-On Subjects",
        //     items: [{ label: "Physics Add-On Course Syllabus", href: "#" }],
        // },
        // {
        //     title: "Published Papers & Patents",
        //     items: [{ label: "Physics Published Papers / Patents", href: "#" }],
        // },
        {
            title: "Mentor List",
            items: [
                {
                    label: "Mentor List 2025-26",
                    href: "https://drive.google.com/file/d/1IfRQUtCD2p59R2Zf945kqLVnx3usvTu1/view?usp=drive_link"
                }
            ],
        },
    ],
};

const PhysicsResources = () => (
    <StudentResourceTemplate resourcePage={resourcePage} />
);

export default PhysicsResources;
